import { Badge, Card, CardBody } from 'reactstrap';
import { ConnectionPhaseText } from '../../../../../helpers/enums/connectionPhaseEnum';
import genericSvg from '../../../../../../src/assets/img/icons/consumerIcons/generic.svg';
import lightOnOffSvg from '../../../../../../src/assets/img/icons/consumerIcons/lightOnOff.svg';
import ledOnOffSvg from '../../../../../../src/assets/img/icons/consumerIcons/ledOnOff.svg';
import rollupSvg from '../../../../../../src/assets/img/icons/consumerIcons/rollup.svg';
import heatingSvg from '../../../../../../src/assets/img/icons/consumerIcons/heating.svg';
import coolingSvg from '../../../../../../src/assets/img/icons/consumerIcons/cooling.svg';
import defaultSvg from '../../../../../../src/assets/img/icons/consumerIcons/default.svg';

const ConsumerCard = ({ it, snapshot, onClick, isSinglePhase }) => {
  const getIconByType = (type) => {
    switch (type) {
      case 0:
        return genericSvg;
      case 1:
        return lightOnOffSvg;
      case 3:
        return ledOnOffSvg;
      case 5:
        return rollupSvg;
      case 6:
        return heatingSvg;
      case 7:
        return coolingSvg;
      default:
        return defaultSvg;
    }
  }

  return (
    <Card
      onClick={() => onClick(it)}
      className={`mb-2 ${snapshot.isDragging ? 'border border-dark bg-soft-info' : ''} ${it.isDeleted ? 'opacity-50' : ''}`}
      style={{ minHeight: '1vh' }}
    >
      <CardBody className="p-0">
        <h6 className="pl-3 pt-3 pr-3 mb-2">
          <img src={getIconByType(it.type)} alt="" className="mr-2" />
          {it.label}
        </h6>
        <div className="pl-3 pr-3 pb-2 d-flex justify-content-between">
          <div className="flex-fill">
            <span className="fs--1">{`#${it.code}`}</span>
          </div>
          {it.power !== 0 && (
            <div className="pl-2 my-auto fs--1">
              <i>{it.power}w</i>
            </div>
          )}
          {!isSinglePhase && (
            <Badge
              color="soft-dark"
              className="my-auto fs--1 font-weight-light ml-3"
              style={{
                backgroundColor: it.hasHighTension && '#FF4D00',
                color: it.hasHighTension && 'white'
              }}
              pill
            >
              {it.connectionPhase &&
                ConnectionPhaseText[it.connectionPhase].toUpperCase()}
            </Badge>
          )}
        </div>
      </CardBody>
    </Card>
  );
};

export default ConsumerCard;
